var openExternalLinkInNewTab;

openExternalLinkInNewTab = function() {
  $.expr[':'].external = function(obj) {
    return !obj.href.match(/^mailto\:/) && !obj.href.match(/^tel\:/) && (obj.hostname !== location.hostname) && !obj.href.match(/^javascript\:/) && !obj.href.match(/^$/);
  };
  return $('a:external').attr('target', '_blank');
};

$(function() {
  return openExternalLinkInNewTab();
});

// ---
// generated by coffee-script 1.9.2